export default {
  'pages.ledger.adminTitle': '记账管理',
  'pages.ledger.consoleTitle': '我的记账',
  'pages.ledger.adminDesc': '查看与管理全部用户的记账流水，支持按用户 / 类型 / 类目 / 时间过滤。',
  'pages.ledger.consoleDesc': '管理归属当前账号的记账流水。',
  'pages.ledger.new': '记一笔',
  'pages.ledger.colUser': '归属用户',
  'pages.ledger.colUserIdFilter': '用户ID',
  'pages.ledger.userIdPlaceholder': '输入用户ID过滤',
  'pages.ledger.colType': '类型',
  'pages.ledger.colAmount': '金额',
  'pages.ledger.colCategory': '类目',
  'pages.ledger.colOccurredAt': '发生时间',
  'pages.ledger.colRemark': '备注',
  'pages.ledger.colCreatedAt': '创建时间',
  'pages.ledger.colTimeRange': '发生时间',
  'pages.ledger.colActions': '操作',
  'pages.ledger.edit': '编辑',
  'pages.ledger.delete': '删除',
  'pages.ledger.confirmDelete': '确定删除该条记账？',
  'pages.ledger.confirm': '确定',
  'pages.ledger.cancel': '取消',
  'pages.ledger.created': '记账成功',
  'pages.ledger.updated': '更新成功',
  'pages.ledger.deleted': '已删除',
  'pages.ledger.opFail': '操作失败',
  'pages.ledger.typeRequired': '请选择类型',
  'pages.ledger.amountRequired': '请输入金额',
  'pages.ledger.amountMin': '金额必须大于0',
  'pages.ledger.categoryRequired': '请选择或输入类目',
  'pages.ledger.categoryPlaceholder': '选择或输入类目',
  'pages.ledger.occurredRequired': '请选择时间',
  'pages.ledger.remarkPlaceholder': '备注（可选）',
  'pages.ledger.targetUser': '归属用户',
  'pages.ledger.targetUserTip': '留空则归属当前登录账号',
  'pages.ledger.searchUserPlaceholder': '输入用户名搜索选择',
  'pages.ledger.noUserFound': '未找到用户',
  'pages.ledger.summaryTitle': '月度汇总',
  'pages.ledger.summaryIncome': '收入',
  'pages.ledger.summaryExpense': '支出',
  'pages.ledger.summaryBalance': '结余',
  'pages.ledger.summaryMonth': '月份',
  'pages.ledger.summaryCatType': '类型',
  'pages.ledger.summaryCatName': '类目',
  'pages.ledger.summaryCatCount': '笔数',
  'pages.ledger.summaryCatTotal': '小计',
  'pages.ledger.currencyLabel': '记账币种',
  'pages.ledger.currencySetFirst': '设置记账币种',
  'pages.ledger.currencyChange': '修改记账币种',
  'pages.ledger.currencyChangeTip': '修改后，历史记录保留原币种，列表与汇总仅统计新币种。确定继续？',
  'pages.ledger.currencySetFirstTip': '首次记账前需先设置币种。选择您日常使用的币种：',
  'pages.ledger.currencyRequired': '请选择币种',
  'pages.ledger.currencySelectPlaceholder': '选择币种',
  'pages.ledger.currencySet': '币种已设置',
  'pages.ledger.type.expense': '支出',
  'pages.ledger.type.income': '收入',
};
